import { getBrowserTimeZone } from "./timeZones";
import { isValidTimeZone } from "./zonedTime";

// The zone marketing message times are entered and shown in: the store's own
// zone, else the merchant's browser zone. `fromStore` tells the form which
// note to show. A store zone this runtime's Intl can't resolve is treated as
// unset rather than crashing the form. Kept apart from timeZones.js so tests
// can mock the browser zone through that module.
export const getMarketingTimeZone = (store) => {
  const storeZone = store?.time_zone;
  if (isValidTimeZone(storeZone)) {
    return { timeZone: storeZone, fromStore: true };
  }
  return { timeZone: getBrowserTimeZone() || "UTC", fromStore: false };
};
